module.exports = __webpack_public_path__ + "static/iron-golem-variant-mtg_afr-2e179e7fae6c6727dda9d72c40f843c6.jpg";